export default __webpack_public_path__ + "static/media/garten.5872bbef.webp";